import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import MenuItem from '@mui/material/MenuItem';
import ColorModeIconDropdown from '../../shared-theme/ColorModeIconDropdown';
import { useNavigate } from "react-router-dom";
import Typography from '@mui/material/Typography';
import Diversity2Icon from '@mui/icons-material/Diversity2';
import { signOut } from "firebase/auth";
import { auth } from "../../firebase"; 
import { useAuth } from "../../context/AuthContext"; 
import Tooltip from '@mui/material/Tooltip';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexShrink: 0,
  borderRadius: `calc(${theme.shape.borderRadius}px + 8px)`,
  backdropFilter: 'blur(24px)',
  border: '1px solid',
  borderColor: (theme.vars || theme).palette.divider,
  backgroundColor: theme.vars
    ? `rgba(${theme.vars.palette.background.defaultChannel} / 0.4)`
    : alpha(theme.palette.background.default, 0.4),
  boxShadow: (theme.vars || theme).shadows[1],
  padding: '8px 12px',
}));

export default function AppAppBar() {
  const [open, setOpen] = React.useState(false);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  
  const handleSignUp = async () => {          
    console.log("signing up");
    navigate("/signup");         
  };

  // custom
  const { currentUser } = useAuth(); // or use auth.currentUser directly
    
  const name = currentUser?.displayName || "User";
  const email = currentUser?.email;
  const photo = currentUser?.photoURL || `https://ui-avatars.com/api/?name=${name}`;
  const nameParts = name.split(' ');
  const firstName = nameParts[0];
  const secondName = nameParts[0];


  const navigate = useNavigate();
  const handleSignIn = async () => {          
    console.log("signing in");
    navigate("/signin");         
  };

  const handleExplore = async () => {              
    navigate("/explore");         
  };

  const handleBlog = async () => {              
    navigate("/blog");         
  };

  
  const handleLogout = async () => {
    try {
      await signOut(auth);
      console.log("Logged out");
      // Optionally redirect to login
     
      navigate("/signin");
    } catch (error) {
          console.error("Logout failed:", error.message);
      }
  };

  return (
    <AppBar
      position="fixed"
      enableColorOnDark
      sx={{
        boxShadow: 0,
        bgcolor: 'transparent',
        backgroundImage: 'none',
        mt: 'calc(var(--template-frame-height, 0px) + 28px)',
      }}
    >
      <Container maxWidth="lg">
        <StyledToolbar variant="dense" disableGutters>
          <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', px: 0 }}>
           
            <Diversity2Icon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />
            <Typography variant="h6" noWrap component="a" href="#app-bar-with-responsive-menu"
              sx={{ mr: 2, display: { xs: 'none', md: 'flex' },
                fontFamily: 'monospace', fontWeight: 700, letterSpacing: '.3rem',
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              NKUVU
            </Typography>
            <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
              <Button variant="text" color="info" size="small" onClick={handleExplore}>
                Explore
              </Button>              
              <Button variant="text" color="info" size="small" onClick={handleBlog}>
                Blog
              </Button>
            </Box>
          </Box>
             <Box>       
          {currentUser? 
            (
             <Box sx={{ flexGrow: 0 }}>
              <Typography variant="body" color='inherit'>{currentUser? `Hi, ${firstName}` : 'Go to sign in page!'} </Typography>
              {/* <Typography variant="body">{currentUser ? `Hi o ${currentUser.displayName}!` : 'Hello, Guest!'} </Typography> */}
              <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }} style={{border:"0"}}>
                  <Avatar alt={email} src={photo} />
                </IconButton>        
              </Tooltip>            
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >           
                <MenuItem onClick={handleCloseUserMenu}>
                  <Typography sx={{ textAlign: 'center' }}>Explore</Typography>
                </MenuItem>
                <MenuItem onClick={handleCloseUserMenu}>
                  <Typography sx={{ textAlign: 'center' }}>E-Tickets</Typography>
                </MenuItem>
                <MenuItem onClick={handleCloseUserMenu}>
                  <Typography sx={{ textAlign: 'center' }}>Blog</Typography>
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                  <Typography sx={{ textAlign: 'center' }}>Sign out</Typography>
                </MenuItem>
              </Menu>
              {/* <Typography variant="body">{currentUser ? `Hi o ${currentUser.displayName}!` : 'Hello, Guest!'} </Typography> */}
              <ColorModeIconDropdown size="medium" style={{border:"none"}} />
              </Box> 
            ) : 
            (
              <Box
                sx={{
                  display: { xs: 'none', md: 'flex' },
                  gap: 1,
                  alignItems: 'center',
                }}
              >
                <Button color="primary" variant="text" size="small"  onClick={handleSignIn}>             
                    Sign in             
                </Button>
                <Button color="primary" variant="contained" size="small" onClick={handleSignUp}>
                  Sign up
                </Button>
                <ColorModeIconDropdown size="medium" style={{border:"none"}} />
              </Box>
            )
          }
           
          </Box>
          
        </StyledToolbar>
      </Container>
    </AppBar>
  );
}
